import React, {useRef, useState} from 'react'
import {TableComp} from 'sz-react-utils-lite'
import { Drawer, Card, Button, Tooltip } from 'antd'
import {DisplayDate, DefaultTablePagination} from '../../../components/_utils/appUtils'
import {useDispatch} from 'react-redux'
import { countArticleByEmailFxn, getMemberHistory } from '../actions'
import ChangeHistory from '../drawers/changeHistory'
import ReactHtmlParser from 'react-html-parser'

const AuthorHistory = (props) => {
  let {visible, onClose, articleId, ids, data} = props
  let [changeHistoryVisible, setChangeHistoryVisible] = useState(false)
  let [totalCount, setTotalCount] = useState()
  let [selectedEmail, setSelectedEmail] = useState()
  let [selectedReviewer, setSelectedReviewer] = useState({})
  const table = useRef()
  const dispatch = useDispatch()
  const columns = [

    {
      key: 'actions',
      title: 'Article Id',
      render: (val, record) => (
        <Tooltip title='Edit Details'>
          <a href={`/articleView/${record._id}`}>
            {record.articleNo}
          </a>
        </Tooltip>

      )
    },
    {
      title: 'Submitted Date',
      key: 'submittedDate',
      dataIndex: 'submittedDate',
      width: 100,
      render: (item) => {
        return item ? DisplayDate(item) : null
      }
    },

    {
      title: 'Article Title',
      dataIndex: 'manuScriptTitle',
      align: 'center',
      key: 'manuScriptTitle',
      render: (text, record, index) => {
        return (
          <>
            {ReactHtmlParser(record.manuScriptTitle)}
          </>
        )
      }
    },
    {
      title: 'Journal',
      dataIndex: 'journal',
      key: 'journal',
      align: 'center',
      searchTextName: 'journal',

    },

    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country'
    },
    {
      title: 'Author',
      dataIndex: 'correspondingAuthor',
      key: 'correspondingAuthor'
    },
    {
      title: 'Email',
      dataIndex: 'correspondingAuthorsEmail',
      key: 'correspondingAuthorsEmail'
    },

    {
      title: 'Volume',
      dataIndex: 'volumeName',
      key: 'volumeName',
      filterRegex: true,
      searchTextName: 'name'
    },
    {
      title: 'Issues',
      dataIndex: 'issues',
      key: 'issues',
      filterRegex: true,
      searchTextName: 'name'
    },
    {
      title: 'Doi Number',
      dataIndex: 'doiNumber',
      key: 'doiNumber',
      align: 'center',
      searchTextName: 'doiNumber',

    },

    {
      title: 'Author',
      dataIndex: 'authors',
      key: 'authors',
      align: 'center',
      render: (authors) => (
        <>
          {Array.isArray(authors) && authors.length > 0 ? (
            authors.map((author, idx) => (
              <div key={idx} style={{ marginBottom: 8 }}>
                <div><strong>Name:</strong> {author.name || '-'}</div>
                <div><strong>Designation:</strong> {author.designation || '-'}</div>
                <div><strong>Email:</strong> {author.email || '-'}</div>
              </div>
            ))
          ) : (
            <div>-</div>
          )}
        </>
      )
    }
  ]
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let obj = {
        email : props.emailId
      }
      let data = await dispatch(countArticleByEmailFxn(obj))
      setTotalCount(data.totalCount)
      setSelectedEmail(data.email)
      resolve({data:data.results})
    })
  }

  const events = {
    showDrawer: (data) => {
      setChangeHistoryVisible(true)
      setSelectedReviewer({
        articleId: articleId,
        ...data
      })
    },
    hideDrawer: () => {
      setChangeHistoryVisible(false)
    },
    submitCallback: () => {
      setSelectedReviewer({})
      setChangeHistoryVisible(false)
      table.current.reload()
    }

  }

  return (
    <Drawer
      title={`Article List - (Total : ${totalCount}) | Email : ${selectedEmail}`}
      width={'90%'}
      visible={visible}
      placement='right'
      onClose={onClose}>

      <Card>
        <TableComp ref={table} columns={columns} apiRequest={apiRequest}
                    pagination={DefaultTablePagination({}, 10)} />
      </Card>


    </Drawer>
  )
}

export default AuthorHistory
